document.addEventListener('on:variant:change', (e) => {
    const variant = e.detail.variant;
    try {
        if (!variant) {
            console.log('Hulk Variant Change - Variant unavailable');
            document.querySelector('.hulkapps-volume-discount-tiers').style.display = 'none';
        } else {
            console.log('Hulk Variant Change - Variant');
            document.querySelector('.hulkapps-volume-discount-tiers').style.display = '';
            window.hulkapps.selected_or_first_available_variant = variant;
            window.hulkapps.selected_or_first_available_variant_id = String(variant.id);
            window.hulkapps.product.selected_variant = variant.id;
            window.hulkapps.product.selected_variant_price = variant.price
            window.product_price = variant.price;
            window.hulkappsStart(hulkapps_jQuery);
        }
    } catch (err) {
        console.log('Hulk Variant Change - Error');
        console.log(err);
    }
})